import React, { createContext, useContext } from 'react';
import { User } from '../../types/models';
import { UserContextType } from '../../types/models/UserContext';

export const UserContext = createContext<UserContextType | null>(null);

export function useUserContext() {
  const context = useContext(UserContext);

  if (context === null) {
    throw new Error('useUserContext must be used within the context');
  }

  return context.user;
}

export function useSetUserContext() {
  const context = useContext(UserContext);

  if (context === null) {
    throw new Error('useUserContext must be used within the context');
  }

  return context.setUser;
}

// Optional: Add a convenience hook for updating specific user fields
export function useUpdateUser() {
  const setUser = useSetUserContext();

  return React.useCallback(
    (userData: Partial<User>) => {
      setUser((currentUser) => (currentUser ? { ...currentUser, ...userData } : currentUser));
    },
    [setUser],
  );
}
